import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { performLogin, saveSession } from '@/lib/auth';
import logoSrc from '@/images/Resstologo2.png';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setError(null);
    try {
      if (!email.trim() || !password) throw new Error('Укажите email и пароль');
      const session = await performLogin(email.trim(), password);
      saveSession(session);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ошибка входа');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-paper px-6">
      <div className="w-full max-w-[380px]">
        <div className="mb-10 flex flex-col items-center">
          <img src={logoSrc} alt="Resstro" className="h-9 w-auto" draggable={false} />
          <span className="mt-4 inline-flex items-center gap-1.5 bg-ink px-2 py-[3px] text-[10px] font-medium uppercase tracking-[0.14em] text-white">
            <ShieldCheck size={11} strokeWidth={2} />
            Platform Console
          </span>
        </div>

        <div className="card p-8">
          <h1 className="text-[22px] font-medium leading-tight tracking-tightest">
            Вход для оператора
          </h1>
          <p className="mt-2 text-[13px] text-ink/60">
            Этот раздел доступен только сотрудникам платформы. Все действия логируются.
          </p>

          <form onSubmit={onSubmit} className="mt-6 space-y-3">
            <label className="block">
              <span className="eyebrow">Email</span>
              <input
                type="email"
                autoComplete="username"
                className="input mt-2"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="operator@resstro.ru"
              />
            </label>
            <label className="block">
              <span className="eyebrow">Пароль</span>
              <input
                type="password"
                autoComplete="current-password"
                className="input mt-2"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </label>

            {error && (
              <div className="border border-red-600/30 bg-red-50 px-3 py-2 text-[12px] text-red-600">
                {error}
              </div>
            )}

            <button type="submit" className="btn-dark w-full" disabled={loading}>
              {loading ? 'Входим…' : 'Войти'}
              <ArrowRight size={14} strokeWidth={1.75} />
            </button>
          </form>
        </div>

        <p className="mt-6 text-center text-[11px] text-ink/40">
          2FA обязательна для prod · IP-whitelist активен
        </p>
      </div>
    </div>
  );
}
